
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/member/demographics",
      function () {
        return require("private-next-pages/mobiworkx/member/demographics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/member/demographics"])
      });
    }
  